// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"c67b112c","241":"2591ce9a","264":"f8767eaf","319":"29d69017","428":"5bf245c3","479":"a4d05d53","506":"31052079","535":"c82c0034","581":"8f67a79e","594":"b4f847d2","638":"270e4587","791":"e567aeb6","839":"99b6c2ae","881":"2ed412f9","905":"ab38b1f5"}[chunkId] + ".chunk.js";
};